import { weatherAPI } from "@/api";
import { paramsBuilder } from "@/utilities";
import { VersionTypesEnum } from "@/enums";

export default {
  getWeather(context) {
    context.commit("showLoading", true);
    context.commit("setState", { isErrorInGetData: false });

    weatherAPI
      .getWeather({
        city: context.getters.cityName,
        lat: context.state.queryParams.sub.xk,
        lng: context.state.queryParams.sub.xl,
        calendarBase: context.state.queryParams.sub.xz,
      })
      .then((res) => {
        if (res && res.data) {
          let tempData = res.data;
          tempData.weather["city"] = context.state.queryParams.sub.xq;

          context.commit("setState", { weatherData: tempData });

          let cityName = tempData.weather.city;
          if (
            context.state.queryParams.xb === VersionTypesEnum.PlayStore &&
            typeof tempData.weather.city !== "object"
          )
            cityName = JSON.stringify({
              cityFaName: tempData.weather.city,
              cityEnName: "",
              cityCustomName: "",
            });
          else if (typeof tempData.weather.city === "object")
            cityName = JSON.stringify(tempData.weather.city);

          const queryData = {
            city: cityName || "تهران",
            // lat: tempData.weather.latitude,
            // lon: tempData.weather.longitude,
            lat: context.state.queryParams.sub.xk || 35.7,
            lon: context.state.queryParams.sub.xl || 51.42,
            temp: tempData.weather.temp,
            icon: decodeURIComponent(tempData.weather.iconSmall),
          };

          // pass new city info to android
          //set dont call uri when weather open from arbaeen
          if (!this.$route.query?.ar)
            window.open(
              "badesaba://weather?action=update&" + paramsBuilder(queryData),
              "_self"
            );
        }
      })
      .catch((error) => {
        if (error.response?.status !== 404) {
          context.commit("setState", { isErrorInGetData: true });
        }

        if (
          error.response?.status === 404 &&
          Object.keys(context.state.weatherData).length === 0
        ) {
          context.commit("setQueryParams", {
            sub: { ...context.state.queryParams.sub, xq: "تهران" },
          });
          context.dispatch("getWeather");
        }
      })
      .finally(() => {
        context.commit("showLoading", false);
      });
  },
};
